import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import EmailOtpModal from '../components/EmailOtpModal'
import api from '../services/api'
import { getToken, saveToken } from '../utils/userData'
import { trackEvent } from '../utils/mixpanel'
import { useEffect, useRef } from 'react'

const Login = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect') || '/dashboard'
  const loginSucceededRef = useRef(false)

  useEffect(() => { trackEvent('Page Viewed', { page: 'Login' }) }, [])

  useEffect(() => {
    if (getToken()) {
      navigate(redirect, { replace: true })
    }
  }, [navigate, redirect])

  const handleSuccess = (data) => {
    const { token } = data
    loginSucceededRef.current = true
    saveToken(token)
    trackEvent('Sign In', {
      login_method: 'email',
      success: true,
    })
    navigate(redirect, { replace: true })
  }

  const requestOtp = async (email) => {
    const response = await api.post('/api/auth/otp', {
      email,
      createIfNotExists: true,
    })
    return {
      success: response.data.success,
      userExists: response.data.data?.userExists,
      code: response.data.data?.code,
    }
  }

  const verifyOtp = async (email, code) => {
    const response = await api.post('/api/auth/verify-otp', { email, code })
    return response.data
  }

  const registerNewUser = async (email, name, phone) => {
    const response = await api.post('/api/auth/complete-registration', {
      email,
      name,
      phone,
    })
    return response.data
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-cream to-primary-100 flex flex-col items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md"
      >
        {/* Logo */}
        <div className="text-center mb-6">
          <Link to="/">
            <img
              src="/logo.png"
              alt="Wellness Loop Logo"
              className="h-14 w-auto mx-auto mb-2"
            />
          </Link>
        </div>
      </motion.div>

      <EmailOtpModal
        isOpen={true}
        onClose={() => { if (!loginSucceededRef.current) navigate(-1) }}
        title="Login"
        emoji="👤"
        emailDescription="Enter your email to continue"
        emailHint="If you're registered, we'll send a code. Otherwise, you can sign up!"
        allowNewUserRegistration={true}
        registerDescription="Complete your profile to continue"
        requestOtp={requestOtp}
        verifyOtp={verifyOtp}
        registerNewUser={registerNewUser}
        onSuccess={handleSuccess}
      />
    </div>
  )
}

export default Login
